<template>
  <div class="tool-use-block">
    <i class="t-iconfont tool-use-block__icon" :class="toolIcon"></i>
    <span class="tool-use-block__text">{{ toolText }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

defineOptions({
  name: 'ToolUseBlock'
})

const props = defineProps({
  toolName: {
    type: String,
    default: ''
  },
  text: {
    type: String,
    default: ''
  },
  // 是否为本条消息的最后一块。
  isLast: {
    type: Boolean,
    default: false
  },
  hasUnfinishedSession: {
    type: Boolean,
    default: false
  },
  // 所有 tool_use 组成的分组：{ items: [...] }，首项为组首。
  allItems: {
    type: Array,
    default: () => []
  },
  // 组首且下方还有相邻的 tool_use：可点击收起，并展示折叠箭头。
  isToolGroupCollapsible: {
    type: Boolean,
    default: false
  },
  // 是否收起。
  isCollapsed: {
    type: Boolean,
    default: false
  }
})

// 搜索/联网类工具用放大镜图标，其余工具用扳手图标。
const toolIcon = computed(() => {
  if (props.toolName === 'Bash') {
    return 'icon-terminal-box-line'
  } else if (props.toolName === 'Read') {
    return 'icon-search-eye-line'
  } else if (props.toolName === 'Write') {
    return 'icon-file-ai-line'
  } else if (props.toolName === 'Edit') {
    return 'icon-file-edit-line'
  } else if (props.toolName === 'Glob') {
    return 'icon-file-code-line'
  } else if (props.toolName === 'Grep') {
    return 'icon-file-search-line'
  } else if (props.toolName === 'WebFetch') {
    return 'icon-search-eye-line'
  } else if (props.toolName === 'WebSearch') {
    return 'icon-global-line'
  } else if (props.toolName === 'DeliverArtifacts') {
    return 'icon-hand-coin-line'
  }
  return 'icon-compasses-2-line'
})

const toolText = computed(() => {
  if (props.isCollapsed && props.isToolGroupCollapsible && props.allItems.length > 1) {
    return `执行工具 ${props.allItems.length} 次`
  }
  if (props.toolName === 'Bash') {
    return `命令执行：${props.text}`
  } else if (props.toolName === 'Read') {
    return `文件读取：${props.text}`
  } else if (props.toolName === 'Write') {
    return `文件生成（创建/覆盖）：${props.text}`
  } else if (props.toolName === 'Edit') {
    return `文件局部编辑：${props.text}`
  } else if (props.toolName === 'Glob') {
    return `代码文件查找：${props.text}`
  } else if (props.toolName === 'Grep') {
    return `文件内容搜索：${props.text}`
  } else if (props.toolName === 'WebFetch') {
    return `页面读取：${props.text}`
  } else if (props.toolName === 'WebSearch') {
    return `联网搜索：${props.text}`
  } else if (props.toolName === 'DeliverArtifacts') {
    return `产物交付：${props.text}`
  }
  return props.text
})
</script>

<style lang="scss" scoped>
.tool-use-block {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: 22px;
  color: #858e9f;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  user-select: none;

  &__icon {
    flex: none;
    margin-right: 8px;
    font-size: 18px;
    line-height: 22px;
  }

  &__text {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  // 独占一行：基础宽度 100% 会强制 flex 换行，图标与第一行文字仍保持同一行。
  &__waiting {
    flex: 0 0 100%;
    // 与上方文字左对齐（跳过图标 16px + 6px 间距）
    padding-left: 22px;
  }
}
</style>
